export enum CodigoEstadoHTTP {
  CORS = 0,
  RESPUESTAS_INFORMATIVAS = 100,
  RESPUESTAS_SATISFACTORIAS = 200,
  REDIRECCION = 300,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  TIME_OUT = 408,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
}
